import { render } from "./GestionEncuestas.vue?vue&type=template&id=6baf8eb5"
import script from "./GestionEncuestas.vue?vue&type=script&lang=js"
export * from "./GestionEncuestas.vue?vue&type=script&lang=js"

import exportComponent from "/Users/alexnovoa/Documents/PersonalDrive/proyectos-vue/exclusiones-front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__